import React from 'react';

export const CreateAssets = React.lazy(
  () => import('./CreateAsset/CreateAsset')
);
export const EditAssets = React.lazy(() => import('./EditAsset/EditAssets'));
export const ViewAsset = React.lazy(() => import('./ViewAsset/ViewAsset'));
